import {
    buttonClasses,
    ComponentsOverrides,
    ComponentsProps,
    ComponentsVariants,
    Theme,
    IconButtonProps,
} from '@mui/material';
import { baseTheme } from '../base-theme';
import { StyleProps } from './utils/dynamicStyle';

function hoverFocusActiveStyle(props: StyleProps<IconButtonProps>) {
    let palette = props.theme.palette.secondary;

    if (props.ownerState?.color && props.ownerState?.color !== 'inherit') {
        palette = props.theme.palette[props.ownerState?.color] ?? props.theme.palette.secondary;
    }

    return {
        [`&.${buttonClasses.focusVisible},:hover,:active`]: {
            backgroundColor: palette?.light,
            color: palette?.dark,
        },
    };
}

export const MuiIconButton: {
    defaultProps?: ComponentsProps['MuiIconButton'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiIconButton'];
    variants?: ComponentsVariants['MuiIconButton'];
} = {
    defaultProps: { size: 'medium', color: 'secondary' },
    styleOverrides: {
        root: (props) => [hoverFocusActiveStyle(props)],
    },
    variants: [
        {
            props: { size: 'small' },
            style: {
                padding: baseTheme.spacing(baseTheme.tokens.spacing.xxs),
            },
        },
    ],
};
